import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import moment from "moment";
import "moment-duration-format";
import ReactGA from "react-ga";
import _ from "lodash";
import { getCurrentPage } from "../helpers";
import Seo from "./Seo";
import gpxImage from "../images/GPX.svg";
import kmlImage from "../images/KML.svg";
import pdfImage from "../images/PDF.svg";

class Ride extends React.Component {	
	trackRideClick = (query) => {
		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: "Show Ride - Sidebar",
			label: query,
		});
	};

	trackMoreInfoClick = (query) => {
		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: "Click Ride More Info Link",
		});
	};

	trackDownloadClick = (ride, type) => {
		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: `Click Download ${ type }`,
			label: ride.name
		});
	};

	render() {
		const { ride } = this.props;
		const duration =
			(parseInt(ride.max_time, 10) - parseInt(ride.min_time, 10)) / 2 +
			parseInt(ride.min_time, 10); // Average
		const query = encodeURI(ride.name.replace("/", "_"));

		// Check if there is an hour value, to decide 'min' or 'hour' suffix.
		const hourCheck = moment(duration, "hours")._i;
		const timeType = hourCheck < 60 ? "mins" : hourCheck < 120 ? "hr" : "hrs";
		const duration_text = duration
			? `<span aria-hidden="true">${ moment
				.duration(duration, "minutes")
				.format(
					`h[:]mm[<span className="unit" aria-hidden="true">${ timeType }</span>]`
				) } </span>`
			: null;
		const duration_srt = duration
			? `<span className="srt">${ moment
				.duration(duration, "minutes")
				.format(`h[hr]mm[mins]`) } </span>`
			: null;

		return (
			<li className="ride-item">
				{ this.props.singleRide && ride.description && (
					<Seo title={ `${ ride.name } leisure ride` } desc={ ride.description } />
				) }

				<h1 className="sub-title single-title">{ ride.name }</h1>

				{ this.props.singleRide && (
					<div className="single-ride-link">
						{ ride.image && (
							<img
								src={ ride.image }
								className="ride-image"
								alt={ `for leisure ride ${ ride.name }` }
							/>
						) }
					</div>
				) }

				{ !this.props.singleRide && (
					<div className="single-ride-link">
						{ ride.image && (
							<img
								src={ ride.image }
								className="ride-image"
								alt={ `for leisure ride ${ ride.name }` }
							/>
						) }
					</div>
				) }

				<div className="ride-item-content">
					<div
						className="ride-color"
						style={ { backgroundColor: `#${ ride.color }` } }
					></div>

					<div className="ride-data">
						{ ride.name && <h3 className="ride-item-title">{ ride.name }</h3> }

						<div className="summary-list ride-summary-list">
							<ul className="summary-list__detailed">
								<li className="summary-item summary-duration">
									<svg className="icon" aria-hidden="true">
										<use xlinkHref="#clock" />
									</svg>
									<span className="summary-item__title faint">Time</span>
									<span dangerouslySetInnerHTML={ { __html: duration_text } }></span>
									<span className="srt" dangerouslySetInnerHTML={ { __html: duration_srt } }></span>
								</li>

								<li className="summary-item summary-distance">
									<svg className="icon wide-icon" aria-hidden="true">
										<use xlinkHref="#road" />
									</svg>
									<span className="summary-item__title faint">Distance</span>
									<span className="value">{ ride.distance } miles</span>
								</li>

								<li className="summary-item summary-difficulty">
									<svg className="icon wide-icon" aria-hidden="true">
										<use xlinkHref={ `#${ ride.difficultyText }` } />
									</svg>
									<span className="summary-item__title faint">Difficulty</span>
									<span className="value">{ ride.difficultyText }</span>
								</li>
							</ul>

							<ul className="summary-list__short">
								{ duration_text && (
									<li className="summary-item">
										<svg className="icon" aria-hidden="true">
											<use xlinkHref="#blue-dot" />
										</svg>
										<span dangerouslySetInnerHTML={ { __html: duration_text } }></span>
										<span className="srt" dangerouslySetInnerHTML={ { __html: duration_srt } }></span>
									</li>
								) }

								{ ride.distance && (
									<li className="summary-item">
										<svg className="icon" aria-hidden="true">
											<use xlinkHref="#blue-dot" />
										</svg>
										<span className="value">
											<span className="srt">Distance: </span>
											{ ride.distance } <span className="unit">miles</span>
										</span>
									</li>
								) }

								{ ride.difficultyText && (
									<li className="summary-item">
										<svg className="icon" aria-hidden="true">
											<use xlinkHref="#blue-dot" />
										</svg>
										<span className="unit">
											<span className="srt">Difficulty: </span>
											{ ride.difficultyText }
										</span>
									</li>
								) }
							</ul>
						</div>
					</div>

					{ ride.description && (
						<p className="ride-description">
							<span>{ ride.description }</span>
						</p>
					) }

					{ !this.props.singleRide && (
						<div className="ride-item-more-info">
							<Link
								to={`/leisure-rides/${query}`}
								onClick={() => {
									this.trackRideClick(ride.name);
									this.trackMoreInfoClick(ride.name);
								}}
							>
								More Info
							</Link>
						</div>
					) }
				</div>

				<div className="ride-item-info">
					{ this.props.singleRide && ride.video && (
						<div className="ride-item-video" aria-hidden="true">
							<iframe
								width="420"
								height="315"
								className="ride-item-video__iframe"
								src={ ride.video }
							></iframe>
						</div>
					) }

					<div className="ride-item-download">
						<h2 className="underline-heading">Download route</h2>
						<div className="downloads">
							<a
								className="button button--primary"
								href={ride.pdf}
								download
								onClick={ () => this.trackDownloadClick(ride, 'PDF') }
							>
								<img src={pdfImage} alt="Download PDF file" /> 
							</a>
							<a
								className="button button--primary"
								href={ride.kml}
								download
								onClick={ () => this.trackDownloadClick(ride, 'KML') }
							>
								<img src={kmlImage} alt="Download KML file" /> 
							</a>
							<a
								className="button button--primary"
								href={ride.gpx}
								download
								onClick={ () => this.trackDownloadClick(ride, 'GPX') }
							>
								<img src={gpxImage} alt="Download GPX file" />
							</a>
						</div>
					</div>
				</div>
			</li>
		);
	}
}

export default Ride;

Ride.contextTypes = {
	router: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Ride.js